



























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Rules from './rules/form.validator';
// import DtTooltip from "src/components/Tooltip/index.vue";

@Component({
  // components: { DtTooltip }
})
export default class muFormItem extends Vue {
  @Prop(String) private label?: string;
  @Prop(String) private tip?: string;
  @Prop({ default: false }) private inline?: boolean;
  @Prop() private prop?: string;
  @Prop({ default: 'blur' }) private trigger?: string;
  @Prop(String) private type?: string;
  @Prop({ default: () => [] }) private validators?: any;

  // 当前校验
  get currentRules() {
    // {type:'', message:'', pattern:'', validator:'', trigger:'blur'}
    if (!this.validators || this.validators.length === 0) return [];
    const resultRules: any = [];
    this.validators.forEach((ruleItem: any) => {
      let result;
      if (typeof (ruleItem) === "object") {
        result = (ruleItem.validator || !ruleItem.type) ? ruleItem : Rules.validObject(ruleItem);
      } else {
        result = Rules[ruleItem] ? Rules[ruleItem] : Rules.validString(ruleItem);
      }
      result && resultRules.push({
        ...result,
        trigger: ruleItem.trigger || this.trigger
      });
    });
    return resultRules;
  }

}
